module.exports = __webpack_public_path__ + "fe77df1654f4bb896b47f00f5e268177.svg";